export function setHref(newHref) {
  location.href = newHref;
}
